import { GraphQuery } from 'dashboard/models/graph-query';
import Action from 'lib/interfaces/Action';

export enum GraphQueryActionType {
  SetGraphQuery = 'graph/SET_GRAPH_QUERY',
  ClearGraphQuery = 'graph/CLEAR_GRAPH_QUERY',
}

interface GraphQueryPayload {
  graphQuery: GraphQuery;
}

export type GraphQueryActions =
  | Action<GraphQueryActionType.SetGraphQuery, GraphQueryPayload>
  | Action<GraphQueryActionType.ClearGraphQuery, {}>;

export function setGraphQuery(
  graphQuery: GraphQuery,
): Action<GraphQueryActionType.SetGraphQuery, GraphQueryPayload> {
  return {
    type: GraphQueryActionType.SetGraphQuery,
    payload: { graphQuery },
  };
}

export function clearGraphQuery(): Action<GraphQueryActionType.ClearGraphQuery, {}> {
  return {
    type: GraphQueryActionType.ClearGraphQuery,
    payload: {},
  };
}
